"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsorFooter = exports.Footer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
exports.Footer = function (_a) {
    var brand = _a.brand, _b = _a.sponsor, sponsor = _b === void 0 ? true : _b;
    var t = react_i18next_1.useTranslation().t;
    var currentYear = new Date().getFullYear();
    return (react_1.default.createElement("footer", null,
        react_1.default.createElement("div", null,
            t('Copyright'),
            " \u00A9 ",
            currentYear,
            " ",
            brand),
        sponsor && (react_1.default.createElement("div", null,
            react_1.default.createElement(exports.SponsorFooter, null)))));
};
exports.SponsorFooter = function (_a) {
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { title: t('Powered by') }, "\u26A1 by "),
        react_1.default.createElement("a", { href: "https://github.com/reactionable/reactionable", target: "_blank", title: t('Reactionable - An effective toolkit for React') }, "Reactionable")));
};
//# sourceMappingURL=Footer.js.map